const imgFiles = [
  {name: "gar1", ext: "webp"},
  {name: "gar2", ext: "webp"},
  {name: "gar3", ext: "webp"},
  {name: "gar4", ext: "webp"},
  {name: "gar5", ext: "webp"},
  {name: "gar6", ext: "webp"},
  {name: "gar7", ext: "webp"},
  {name: "gar8", ext: "webp"},
  {name: "gar9", ext: "webp"},
];

export default imgFiles